import React from 'react';
import TooltipReplyAll from './EmailsTooltip/TooltipReplyAll';
import TooltipReply from './EmailsTooltip/TooltipReply';
import TooltipForward from './EmailsTooltip/TooltipForward';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { emailSliceAction } from '../../store/emailSlice';
import emptybox from "./../../assets/images/empty-box.png";
import DOMPurify from 'dompurify';

const MailView = () => {
    const dispatch = useDispatch()
    const emailDetails = useSelector((state:any)=>{return state.emailSlice.emailDetails})
    const emailLoading = useSelector((state:any)=>{return state.emailSlice.emailLoading})
    
    const onClickEmailAction = (action:any) => {
        dispatch(emailSliceAction.setEmailAction(action))
    }

    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="ChatBox">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Mail view</h6>
                    <div className='d-flex'>
                        {emailDetails && <ul className='mail-action list-unstyled d-flex m-0'>                            
                            <li onClick={()=>{onClickEmailAction('ReplyAll')}}><TooltipReplyAll /></li>
                            <li onClick={()=>{onClickEmailAction('Reply')}}><TooltipReply /></li>
                            <li onClick={()=>{onClickEmailAction('Forward')}}><TooltipForward /></li>
                        </ul>}
                    </div>
                </div>
                <div className="card-body height-400">
                    {(emailLoading) && <Spinner className='spinner-center' variant="primary" as="span" animation="border" role="status" aria-hidden="true"/>}
                    {(!emailLoading && emailDetails) && <div className='viewmail-wapper'>
                       <h6 className='mail-id'>From: {emailDetails?.from[0]?.name || ''} 	&#60;<span className='text-primary'>{emailDetails?.from[0]?.address}</span>&#62; {new Date(emailDetails.date).toLocaleString()}</h6>
                       <h6 className='mail-id'>To: {emailDetails?.to.map((ToList:{address:string})=>{return ToList.address}).join(",")|| ''} </h6>
                       {emailDetails?.cc?.length > 0  &&<p className='sub-content mb-3'>CC: {emailDetails?.cc.map((ToList:{address:string})=>{return ToList.address}).join(",")|| ''} </p>}
                       <div className='sub-title'>Subject</div>
                       <div className='sub-content mb-3'>{emailDetails?.subject}</div>

                    {emailDetails?.attachment?.length > 0 && <div className='sub-title'>Attachment</div>}
                       <div className='mail-attachment'>
                           <ul className='attachment-list d-flex list-unstyled'>
                                {emailDetails?.attachment?.length > 0 && emailDetails?.attachment?.map((attachment:any, index:number) => {
                                    const byteCharacters = atob(attachment.content);
                                    const byteNumbers = new Array(byteCharacters.length);
                                    for (let i = 0; i < byteCharacters.length; i++) {
                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                    } 
                                    const byteArray = new Uint8Array(byteNumbers);
                                    const blobs = new Blob([byteArray],{type :attachment.contentType});
                                    var url = URL.createObjectURL(blobs);
                                    let ispicture = attachment.contentType==='image/png' || attachment.contentType==='image/jpeg'
                                    return (
                                        <li key={index}>
                                            {ispicture && <div className='attachment-img'>
                                                <img src={"data:"+attachment.contentType+";base64 ,"+attachment.content} alt="attachment"></img>
                                            </div>}
                                            <div className='attachment-caption'>
                                                <a href={url} target="_blank" download={attachment.filename} rel="noreferrer">{attachment.filename}</a>
                                            </div>
                                        </li>
                                    )
                                })}
                           </ul>
                       </div>
                       <div className='sub-title'>Content</div>
                       <div className='mail-content mb-3' dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(emailDetails.body, {
                            ALLOWED_ATTR: ["href", "target", "rel"]
                       })}}></div>
                    </div>}

                       
                    {(!emailLoading && emailDetails !== emailDetails) && 
                        <div className='empty-data'>
                            <img className='empty-icon' src={emptybox} alt="empty box icon" />
                            <h4>No data available</h4>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default MailView;